/**
 * `Н212` (`АУД-142`, Л; п. 18): строка «последнее обращение по ключу».
 *
 * Сервер отдаёт только отметку времени (`apiKeyLastUsedAt`), сам ключ и его
 * хэш наружу не приходят. `null` — ключом ещё не пользовались; это не «давно»,
 * а именно «не использовался».
 */
export function formatApiKeyLastUsedAt(
  value?: string | null,
): string {
  if (!value) return "не использовался";

  const at = new Date(value);

  if (Number.isNaN(at.getTime())) return "не использовался";

  return at.toLocaleString("ru-RU");
}
